<div class="recovery-codes">
  <p class="recovery-codes-title">
    {{
      (isGenerate || !isNew
        ? 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.TITLE'
        : 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.NEW_TITLE'
      ) | translate
    }}
  </p>
  <p class="recovery-codes-description">
    {{
      (isNew
        ? 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.NEW_DESCRIPTION'
        : 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DESCRIPTION'
      ) | translate
    }}
  </p>

  <div class="recovery-codes__list">
    <div class="recovery-codes__list__item" *ngFor="let code of recoveryCodes">
      <span
        class="recovery-codes__list__item_text"
        [ngClass]="{ 'recovery-codes__list__item_text--striped': code.status === 'CURRENT_USED' }"
      >
        {{ code.plainTextCode }}
      </span>
    </div>
  </div>
  <button class="recovery-codes_copy" mat-icon-button (click)="copyRecoveryCodes()">
    {{ 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.COPY' | translate }}
    <mat-icon>content_copy</mat-icon>
  </button>

  <div class="recovery-codes__buttons">
    <ng-content></ng-content>
  </div>
</div>
